import 'components/ordering/multiple-baskets/basket-editor/basket-editor.js'
import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { CSESlideIn } from '@cloudsuite/mosaic-elements'
import { BasketChangedEvent, BasketFormResetEvent } from 'components/ordering/multiple-baskets/basket-events.js'
import { slideInStyle } from 'components/ordering/multiple-baskets/basket.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


initializeIconsByRole({
  'csc-basket-editor-slide-in.edit': { name: 'pen-to-square', style: 'regular' },
})

@customElement('csc-basket-editor-slide-in')
export class CSCBasketEditorSlideIn extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, slideInStyle]

  constructor() {
    super()
    this.addEventListener(BasketChangedEvent.type, this.close)
    this.addEventListener(BasketFormResetEvent.type, this.close)
  }

  override disconnectedCallback(): void {
    this.removeEventListener(BasketChangedEvent.type, this.close)
    this.removeEventListener(BasketFormResetEvent.type, this.close)
  }

  @property({ attribute: 'ordering-endpoint' })
  orderingEndpoint = ''

  @property({ attribute: 'shop-id' })
  shopId = 0

  @property({ attribute: 'party-id' })
  partyId = 0

  @property({ type: Number, attribute: 'user-id' })
  userId: number | null = null

  @query('cse-slide-in')
  slideIn!: CSESlideIn

  close() {
    this.slideIn.close()
  }

  override render() {
    return html`
      <cse-button @click="${() => this.slideIn.open()}" size="small" class="edit-basket-button">
        <cse-icon icon-role="csc-basket-editor-slide-in.edit" slot="prefix"></cse-icon>
        ${t('edit_basket_button', { ns: 'csc-basket-editor-slide-in', default: 'Change basket (name)' })}
      </cse-button>

      <cse-slide-in>
        <div slot="header" class="basket-editor-slide-in-header">
          ${t('slide_in_header', { ns: 'csc-basket-editor-slide-in', default: 'Edit basket' })}
        </div>

        <csc-basket-editor
          ordering-endpoint="${this.orderingEndpoint}"
          shop-id="${this.shopId}"
          party-id="${this.partyId}"
          user-id="${this.userId}"
          class="basket_creator"
        ></csc-basket-editor>
      </cse-slide-in>
    `
  }
}
